// Validate a post-login redirect target. Accept only the dispatch-api OAuth
// authorize URL, or a genuine same-origin relative path. Resolve through the
// URL parser so browser tab/newline/CR stripping can't smuggle a
// protocol-relative ("//evil.com") escape past us. Everything else -> '/'.
export function safeReturnUrl(raw: string | undefined, apiOrigin: string): string {
  if (!raw) return '/';
  // A leading '%' means a producer pre-encoded the value (Next decodes query
  // params exactly once, and real paths start with '/') — fail safe to '/'
  // instead of redirecting to a literal "/%2F..." path that 404s.
  if (raw.startsWith('%')) return '/';
  // (a) Absolute URL: allow ONLY the AS authorize endpoint on the api origin.
  try {
    const abs = new URL(raw);
    return abs.origin === apiOrigin && abs.pathname === '/oauth/authorize'
      ? raw
      : '/';
  } catch {
    // not an absolute URL -> try as a relative path below
  }
  // (b) Relative path: resolve against a sentinel base; safe only if it stays
  // on that origin (a protocol-relative/whitespace escape lands elsewhere).
  try {
    const base = 'https://app.invalid';
    const rel = new URL(raw, base);
    if (rel.origin === base) {
      // An uninterpolated Next route pattern ("/p/[pid]/...") makes
      // router.push throw href-interpolation-failed — fail safe instead.
      if (rel.pathname.includes('[')) return '/';
      return rel.pathname + rel.search + rel.hash;
    }
  } catch {
    /* ignore */
  }
  return '/';
}
